import { hyphenate } from "neetocist";
import { Segments } from "neetofilters";
import { Typography, Tag } from "neetoui";
import { is } from "ramda";

import CheckPointNavLinks from "./CheckPointNavLink";

import { SUB_LINK_TYPES } from "../../constants";
import { isSubRouteActive } from "../../utils";

const SubLink = ({
  to,
  href,
  onClick,
  label,
  type = SUB_LINK_TYPES.SYSTEM_VIEW,
  count,
  isSectionHeader,
  isCountsLoading,
  "data-testid": dataTestid,
  entity = "",
  columns = [],
  baseUrl,
  isActive,
  tag,
}) => {
  if (type === SUB_LINK_TYPES.SEGMENTS) {
    return <Segments {...{ baseUrl, columns, entity }} isIndependent={false} />;
  }

  const dataTestidPrefix = dataTestid || hyphenate(label);

  const renderCount = count => (count > 999 ? "999+" : count);

  const isSubLinkActive = () =>
    !isSectionHeader &&
    (is(Function, isActive) ? isActive() : isSubRouteActive(to, location));

  return (
    <CheckPointNavLinks
      {...{ href, onClick, to }}
      activeClassName="active"
      className="neeto-molecules-sidebar__sublink neeto-ui-flex neeto-ui-items-center neeto-ui-select-none"
      data-testid={`${dataTestidPrefix}-sub-link`}
      isActive={isSubLinkActive}
    >
      <Typography
        className="neeto-molecules-sidebar__link-sub-label neeto-ui-flex-grow flex items-center gap-2"
        component="span"
        data-testid={`${dataTestidPrefix}-sub-link-label`}
        style="body2"
      >
        {label}
        {tag && <Tag {...tag} />}
      </Typography>
      <Typography
        className="neeto-molecules-sidebar__link-sub-count neeto-ui-flex-shrink-0"
        component="span"
        data-testid={`${dataTestidPrefix}-sub-link-count`}
        style="body2"
      >
        {isCountsLoading ? (
          <div className="neeto-ui-rounded neeto-ui-bg-gray-200 h-4 w-4 animate-pulse" />
        ) : (
          renderCount(count)
        )}
      </Typography>
    </CheckPointNavLinks>
  );
};

export default SubLink;
